// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__dlTwV","header__logo":"style_header__logo__n3_OV"};